import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const premiumEase = [0.16, 1, 0.3, 1];

const Testimonials = () => {
  const scrollToForm = () => document.getElementById('cadastro')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden z-10 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: premiumEase }}
          className="text-center mb-12 lg:mb-16"
        >
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-stone-900">
            Quem ama, <span className="italic text-amber-800 font-normal">confia.</span>
          </h2>
        </motion.div>

        <div className="flex flex-col items-center gap-12">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 1, ease: premiumEase }}
            className="relative max-w-2xl w-full bg-amber-50 border border-amber-200 rounded-[2.5rem] p-8 sm:p-12 shadow-xl shadow-amber-900/5 text-center"
          >
            <div className="flex justify-center gap-1 mb-8 text-amber-600">
              {[...Array(5)].map((_, i) => (
                <SafeIcon key={i} name="Star" className="w-5 h-5 fill-current" />
              ))}
            </div>

            <blockquote className="text-stone-800 text-xl sm:text-2xl leading-relaxed mb-10 font-serif italic">
              "Excelente e acessível. Um agradecimento especial à Dra. Luene, que atendeu meu Theozinho com todo o carinho do mundo. É notável que todos lá trabalham com amor à profissão. Recomendo!"
            </blockquote>

            <div className="flex flex-col items-center gap-2 pt-8 border-t border-amber-200/50">
              <h4 className="text-stone-900 font-bold text-lg">Mariana Silva</h4>
              <p className="text-amber-800 text-[11px] font-black uppercase tracking-[0.2em] flex items-center gap-2">
                Mãe do Theozinho 🐾
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <button 
              onClick={scrollToForm}
              className="bg-amber-800 text-white px-10 py-5 rounded-xl font-bold uppercase tracking-[0.2em] text-xs hover:bg-amber-900 transition-all shadow-lg flex items-center gap-3"
            >
              Proporcionar esse carinho ao meu pet <SafeIcon name="ArrowRight" className="w-4 h-4" />
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;